<template>
    <v-main>
        <AppBar />
        <v-layout fill-height column>
            <v-container flex-fill fluid class="pt-0">
                <div class="py-5">
                    <div class="d-flex align-center fs-18 fw-700"><span class="badge mr-2">티켓</span>타이틀</div>
                    <div class="secondary--text mt-2">1개월(4주)*주2회 전문가개입</div>
                    <div class="fs-16 fw-700 primary--text line-height-1 mt-6">10,000원</div>
                </div>
                <hr class="hr"/>
                <div class="py-9">
                    <v-form class="form-item" v-model="valid">
                        <label class="label">구매 취소 사유</label>
                    <div class="input-group">
                        <v-text-field append-icon="mdi-menu-down" solo flat filled v-model="selectItem" readonly
                            placeholder="구매 취소 사유을 선택해주세요" @click="rollerPickerOpen" />
                    </div>
                    <v-textarea
                        filled
                        solo
                        flat
                        background-color="#F7F7F7"
                        no-resize
                        placeholder="구매 취소 사유를 입력해주세요."
                        class="pa-0 textarea"
                        style="margin-top: -18px;"
                    ></v-textarea>
                    </v-form>

                </div>
            </v-container>
            <div class="footer-btns">
                <BlackBtn str="구매 취소하기" :disabled="true" />
            </div>
        </v-layout>
        <SelectRollerPicker ref="rollerPicker" @selectValue="selectValue" />
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import SelectRollerPicker from "@/components/layout/bottomSheet/SelectRollerPicker";
export default {
    data: () => ({
        valid: false,
        name: '',
        phone: '',
        address: '',
        addressDetails: '',
        items: ['상품이 마음에 들지않음 (단순변심)', '상품이 마음에 들지않음 (단순변심)1', '상품이 마음에 들지않음 (단순변심)2', '상품이 마음에 들지않음 (단순변심)3'],
        selectItem: '',
    }),
    components: {
        BlackBtn,
        SelectRollerPicker,
    },
}
</script>
<style lang="scss" scoped>
.badge {
    border: 1px solid $color-main;
    padding: 0 10px;
    height: 22px;
    font-size: 12px;
    font-weight: 500;
    color: $color-main;
    background: transparent;
    border-radius: 20px;
    width: auto;
    flex-shrink: 0;
}
.textarea::v-deep {
    textarea::placeholder  {
      font-size: 14px;
    }
}
</style>